// Module
var code = "<template id=\"dot-template\"> <div class=\"dots__dot\"></div> </template> ";
// Exports
export default code;